import React from "react";
import SignUpForm from "../../../utilities/SignUpForm";

export default function HeroWeiwei({ slice }) {
  const formId = slice?.primary?.hs_id?.text;
  return (
    <div className="relative w-full h-[100svh] overflow-hidden pt-[72px]">
      <div className="relative w-full h-full">
        {slice.primary.video_background?.url && (
          <video
            className="absolute top-0 left-0 w-full h-full object-cover z-10"
            autoPlay
            loop
            muted
            playsInline
          >
            <source
              src={slice.primary.video_background.url}
              type="video/webm"
            />
            Your browser does not support the video tag.
          </video>
        )}

        {/* gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-slate-950 to-transparent z-10"></div>

        <div className="md:max-w-7xl px-6 xl:px-16 mx-auto py-10 z-20 relative flex flex-col justify-end h-full">
          <h1 className="font-manrope text-4.5xl md:text-5xl lg:text-5.5xl font-medium leading-tight mb-6 text-white max-w-max">
            {slice.primary.title?.text || ""}
          </h1>
          <p className="font-inter max-w-[750px] text-base md:text-lg font-normal leading-7 tracking-tight text-white text-opacity-80 mb-10">
            {slice.primary.descriptor_text?.text || ""}
          </p>
          {slice.primary.display_secondary_cta ? (
            <div className="w-full sm:w-auto sm:inline-block cursor-pointer">
              <a
                href={slice.primary.secondary_cta_url.url}
                target="_blank"
                className="px-4 py-2 text-white font-manrope font-semibold bg-purple-1500 hover:bg-[#5E24FF] rounded-[40px] text-center block sm:inline-block w-full sm:w-auto"
              >
                {slice.primary.secondary_cta.text}
              </a>
            </div>
          ) : (
            <div className="w-full">
              <SignUpForm subscribe variant="heroWeiwei" formId={formId} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
